import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'synfrastructure';
import getDecodedToken from '../../../common/auth/utils/getDecodedToken';
import SessionList from '../../../common/components/SessionList';
import Icon from '../../../common/icons/Icon';
import Loading from '../../../common/components/Loading';
import NewSessionModal from './NewSessionModal';
import BookedSessionModal from './MovementSpecialistAdminBookedSessionModal';
import { pushToast } from '../../../redux/actions';
import { cancelBookedSession, completeSession, getSessions, respondToSessionRequest } from '../redux/actions';
import { selectBookedSessions, selectCompletedSessions, selectNewSessions } from '../redux/selectors';
import { sendIntercomEvent } from '../../../common/events';

class MovementSpecialistAdminSessionsPage extends Component {
  state = {
    bookedSessionModalVisible: false,
    modalActiveSession: null,
    newSessionModalVisible: false,
  };

  componentWillMount() {
    this.props.dispatch(getSessions(getDecodedToken().sub));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.respondToSession.get('loading') && nextProps.respondToSession.get('loaded')) {
      this.props.dispatch(pushToast({ message: 'Your response has been saved successfully' }));
      this.toggleNewSessionModal(null);
    }

    if (this.props.cancelSession.get('loading') && nextProps.cancelSession.get('loaded')) {
      this.props.dispatch(pushToast({ message: 'Session cancelled successfully' }));
      this.toggleBookedSessionModal(null);
    }

    if (this.props.completeSession.get('loading') && nextProps.completeSession.get('loaded')) {
      this.props.dispatch(pushToast({ message: 'Session completed successfully' }));
      this.toggleBookedSessionModal(null);
    }
  }

  toggleNewSessionModal = session => {
    this.setState(state => ({
      modalActiveSession: session,
      newSessionModalVisible: !state.newSessionModalVisible,
    }));
  };

  toggleBookedSessionModal = session => {
    this.setState(state => ({
      modalActiveSession: session,
      bookedSessionModalVisible: !state.bookedSessionModalVisible,
    }));
  };

  onSessionAccept = values => {
    const session = this.state.modalActiveSession;
    const payloadValues = {
      acceptedSessionDate: values.acceptedSessionDate,
      responseNote: values.responseNote,
      status: 'accepted',
    };

    this.props
      .dispatch(respondToSessionRequest(session.movement_specialist_user_id, session.id, payloadValues))
      .then(() => {
        sendIntercomEvent('ms_confirm', {
          requested_dates: session.requested_dates,
          accepted_date: session.acceptedSessionDate,
          message: session.note,
          member: {
            id: session.user.id,
            name: session.user.name,
          },
        });
      });
  };

  onSessionReject = values => {
    const session = this.state.modalActiveSession;
    const payloadValues = {
      responseNote: values.responseNote,
      status: 'rejected',
    };

    this.props
      .dispatch(respondToSessionRequest(session.movement_specialist_user_id, session.id, payloadValues))
      .then(() => {
        sendIntercomEvent('ms_reject', {
          requested_dates: session.requested_dates,
          message: session.note,
          member: {
            id: session.user.id,
            name: session.user.name,
          },
        });
      });
  };

  onSessionCancel = values => {
    const session = this.state.modalActiveSession;
    const payloadValues = {
      cancelNote: values.cancelNote,
    };

    this.props
      .dispatch(cancelBookedSession(session.movement_specialist_user_id, session.id, payloadValues))
      .then(() => {
        sendIntercomEvent('ms_cancel', {
          message: values.cancelNote,
          date: session.accepted_date,
          member: {
            id: session.user.id,
            name: session.user.name,
          },
        });
      });
  };

  onSessionComplete = session => {
    this.props.dispatch(completeSession(session.movement_specialist_user_id, session.id));
  };

  render() {
    const {
      cancelSession,
      loaded,
      newSessions,
      bookedSessions,
      completedSessions,
      completeSession,
      respondToSession,
    } = this.props;
    const { bookedSessionModalVisible, modalActiveSession, newSessionModalVisible } = this.state;

    if (!loaded) {
      return <Loading />;
    }

    return (
      <div className="ms-admin__sessions">
        {newSessionModalVisible && (
          <Modal
            isVisible
            onClose={this.toggleNewSessionModal}
            closeButton={
              <button>
                <Icon icon="Close" />
              </button>
            }
          >
            <NewSessionModal
              onAccept={this.onSessionAccept}
              onReject={this.onSessionReject}
              loading={respondToSession.get('loading')}
              session={modalActiveSession}
              toggleModal={this.toggleNewSessionModal}
            />
          </Modal>
        )}
        {bookedSessionModalVisible && (
          <Modal
            isVisible
            onClose={this.toggleBookedSessionModal}
            closeButton={
              <button>
                <Icon icon="Close" />
              </button>
            }
          >
            <BookedSessionModal
              onCancel={this.onSessionCancel}
              loading={cancelSession.get('loading') || completeSession.get('loading')}
              session={modalActiveSession}
              onItemComplete={this.onSessionComplete}
              toggleModal={this.toggleBookedSessionModal}
            />
          </Modal>
        )}
        <SessionList
          context="movement-specialist"
          headerTitle="New"
          icon="Envelope"
          onItemView={this.toggleNewSessionModal}
          sessions={newSessions}
          type="new"
        />
        <SessionList
          context="movement-specialist"
          headerTitle="Booked"
          icon="Calendar"
          onItemView={this.toggleBookedSessionModal}
          sessions={bookedSessions}
          type="booked"
        />
        <SessionList
          completing={completeSession.get('loading')}
          context="movement-specialist"
          headerTitle="Completed"
          icon="CheckmarkCircle"
          onItemView={this.toggleBookedSessionModal}
          sessions={completedSessions}
          type="completed"
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  bookedSessions: selectBookedSessions(state),
  cancelSession: state.subscription.movementSpecialistAdmin.cancelSession,
  completeSession: state.subscription.movementSpecialistAdmin.completeSession,
  completedSessions: selectCompletedSessions(state),
  loaded: state.subscription.movementSpecialistAdmin.sessions.get('loaded'),
  newSessions: selectNewSessions(state),
  respondToSession: state.subscription.movementSpecialistAdmin.respondToSession,
});

export default connect(mapStateToProps)(MovementSpecialistAdminSessionsPage);



// WEBPACK FOOTER //
// ./src/subscription/movement-specialist-admin/sessions/MovementSpecialistAdminSessionsPage.js